import React from 'react';
import BaseTypography from 'src/components/Text/BaseTypography';
import { SignatureStatusTypes } from 'src/store/files/types';
import { BaseStatusIndicator } from 'src/components/AgGrid/Renderer/BaseStatusIndicator';
import * as Colors from 'src/theme/colors';

interface ESignatureStatusIndicatorProps {
  signatureStatus: SignatureStatusTypes;
}
export const ESignatureStatusIndicator: React.FC<
  ESignatureStatusIndicatorProps
> = ({ signatureStatus }) => {
  const isSignatuStatusCompleted =
    signatureStatus === 'done' || signatureStatus === 'signed';

  return (
    <BaseStatusIndicator
      title={
        <>
          <BaseTypography
            fontType="13Medium"
            style={{ color: Colors.BlackHeadings }}
          >
            eSignature Status
          </BaseTypography>
          <BaseTypography
            fontType="12Regular"
            style={{ color: Colors.BlackSmall }}
          >
            {isSignatuStatusCompleted ? 'Completed' : 'In progress'}
          </BaseTypography>
        </>
      }
      isSuccess={isSignatuStatusCompleted}
      hasTooltip
    />
  );
};
